import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Crown, PhoneCall, MessageCircle, BellRing, BadgeCheck, Loader2 } from "lucide-react";

const BENEFITS = [
  { icon: PhoneCall, text: "Direct owner mobile numbers on every listing" },
  { icon: MessageCircle, text: "Direct WhatsApp link to owners & agents" },
  { icon: BellRing, text: "Priority alerts for new matching properties" },
  { icon: BadgeCheck, text: "Zero brokerage guarantee badge" },
];

export default function MembershipModal() {
  const { membershipOpen, setMembershipOpen, user, openAuth } = useAuth();
  const [busy, setBusy] = useState(false);

  const pay = async () => {
    if (!user) {
      setMembershipOpen(false);
      openAuth();
      return;
    }
    setBusy(true);
    try {
      const res = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = res.data.checkout_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not start payment");
      setBusy(false);
    }
  };

  return (
    <Dialog open={membershipOpen} onOpenChange={setMembershipOpen}>
      <DialogContent className="sm:max-w-md" data-testid="membership-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading text-2xl">
            <Crown className="h-6 w-6 text-violet-600" /> Owner Direct Contact Pass
          </DialogTitle>
        </DialogHeader>
        <div className="rounded-xl bg-violet-50 p-4 text-center">
          <span className="font-price text-4xl font-bold text-violet-700">₹99</span>
          <span className="ml-2 text-sm text-muted-foreground">one-time · lifetime access</span>
        </div>
        <ul className="space-y-3">
          {BENEFITS.map((b, i) => (
            <li key={i} className="flex items-center gap-3 text-sm">
              <b.icon className="h-5 w-5 text-violet-600" /> {b.text}
            </li>
          ))}
        </ul>
        <Button
          data-testid="membership-pay-button"
          className="w-full bg-violet-600 text-white hover:bg-violet-700"
          disabled={busy}
          onClick={pay}
        >
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Pay ₹99 Securely with Stripe"}
        </Button>
        <p className="text-center text-xs text-muted-foreground">
          Card, UPI & more via Stripe checkout. Test card: 4242 4242 4242 4242
        </p>
      </DialogContent>
    </Dialog>
  );
}
